// extracted by mini-css-extract-plugin
export default {"plain-text":"v28CyGRxxX","plainText":"v28CyGRxxX"};
    if(module.hot) {
      // 1643570452694
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  